import { useI18n } from '../../shared/i18n/I18nProvider';
import { ArrowUpRight, CalendarDays, Check, ShieldCheck, Sparkles, TrendingUp } from 'lucide-react';
import { Outlet } from 'react-router';
import { Logo } from '../../shared/ui';
import styles from './authLayout.module.css';

export function AuthLayout() {
  const { t } = useI18n();

  return <main className={styles.shell}>
    <section className={styles.story} aria-label={t("Giới thiệu Store-X")}>
      <div className={styles.brand}><Logo light /><span className={styles.cloud}><i />{t("Cloud workspace")}</span></div>
      <div className={styles.storyContent}>
        <span className={styles.eyebrow}><Sparkles size={13} />{t("KHÔNG GIAN DÀNH CHO CHỦ CỬA HÀNG")}</span>
        <h2>{t("Hiểu cửa hàng.")}<br />{t("Chủ động mỗi ngày")}<span>.</span></h2>
        <p>{t("Lịch hẹn, khách hàng và kết quả kinh doanh.")}<br />{t("Mọi điều bạn cần, trong một góc nhìn.")}</p>
        <div className={styles.preview}>
          <div className={styles.previewHead}><span><CalendarDays size={16} />{t("Một ngày tại Beauty House")}</span><small>{t("BẢN MINH HỌA")}</small></div>
          <div className={styles.appointment}><time>09:00</time><div><strong>Linh Nguyễn</strong><span>{t("Nhuộm tóc & phục hồi")}</span></div><span className={styles.confirmed}><Check size={11} />{t("Hoàn thành")}</span></div>
          <div className={styles.appointment}><time>10:30</time><div><strong>Thu Hà</strong><span>{t("Chăm sóc móng chuyên sâu")}</span></div><span className={styles.inService}>{t("Đang phục vụ")}</span></div>
          <div className={styles.miniStats}><div><small>{t("DOANH THU HÔM NAY")}</small><strong>12.450.000 <span>₫</span></strong></div><span className={styles.trend}><TrendingUp size={15} />12,5%</span></div>
        </div>
        <div className={styles.promise}><span className={styles.promiseIcon}><ArrowUpRight size={20} /></span><div><strong>{t("Tập trung vào trải nghiệm khách hàng.")}</strong><p>{t("Để Store-X giúp bạn theo dõi phần còn lại.")}</p></div></div>
      </div>
      <footer className={styles.storyFooter}><ShieldCheck size={15} />{t("Cùng một cửa hàng. Kết nối nhiều trải nghiệm.")}<span>STORE-X © 2026</span></footer>
    </section>
    <section className={styles.formSide}><Outlet /></section>
  </main>;
}
